<style lang="scss" scoped>

div.list-group-item {
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
}

.list-enter-active,
.list-leave-active {
  transition: transform 1s;
}

.list-enter-from,
.list-leave-to {
  opacity: 0;
}

</style>

<template>
    <Content>
        <div class="page-header d-print-none mb-2">
            <div class="row align-items-center">
              <div class="col">
                <!-- Page pre-title -->
                <div class="page-pretitle">
                  Anlegen, Auswählen & Verwalten
                </div>
                <h2 class="page-title">
                  Entnahmestellen
                </h2>
              </div>
              
              <div class="col-auto ms-auto d-print-none">
                <div class="btn-list">
                  <a href="#" class="btn btn-info d-none d-sm-inline-block" @click="openNewModal">
                    <!-- Download SVG icon from http://tabler-icons.io/i/plus -->
                    <svg xmlns="http://www.w3.org/2000/svg" class="icon" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round"><path stroke="none" d="M0 0h24v24H0z" fill="none"></path><line x1="12" y1="5" x2="12" y2="19"></line><line x1="5" y1="12" x2="19" y2="12"></line></svg>
                    Neuen Entnahmestelle anlegen
                  </a>
                  <a href="#" class="btn btn-info d-sm-none btn-icon" aria-label="" @click="openNewModal">
                    <!-- Download SVG icon from http://tabler-icons.io/i/plus -->
                    <svg xmlns="http://www.w3.org/2000/svg" class="icon" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round"><path stroke="none" d="M0 0h24v24H0z" fill="none"></path><line x1="12" y1="5" x2="12" y2="19"></line><line x1="5" y1="12" x2="19" y2="12"></line></svg>
                  </a>
                </div>
              </div>
            </div>
        </div>
        
      <Alert type="info" :show="alertEmpty">
          <template v-slot:title>Entnahmestellen noch nicht angelegt</template>
           Zum Anlegen einer Entnahmestelle, klicken Sie bitte rechts oben auf das Plus.
      </Alert>
      
      <Alert type="success" :show="alertNew"  :timeout="12000">
           <template v-slot:title>Neuer Entnahmestellen angelegt</template>
           Die neue Entnahmestellen wurde angelegt. Sie finden ihn ganz oben in der Liste.
      </Alert> 
        
        <div class="row">
            <div class="col-12">
            
                <div v-visible="loading" class="progress progress-sm mb-2">
                    <div class="progress-bar progress-bar-indeterminate"></div>
                </div>
            
                <div v-show="waterPointList.length > 0" class="card">
                  <div class="list-group list-group-flush list-group-hoverable">
                    <transition-group name="fade_" tag="div">
                    <div v-for="waterPoint in waterPointList" v-bind:key="waterPoint.id" class="list-group-item">
                        <router-link v-if="isReferrer" :to="routeTo" @click="setSelectedWaterPoint(waterPoint)">
                            <WaterPointItem :waterPoint="waterPoint" ></WaterPointItem>
                        </router-link>
                        <WaterPointItem v-else :waterPoint="waterPoint" >
                        </WaterPointItem>
                    </div>
                    </transition-group>
                  </div>
                </div>       
            </div>
        </div>
    </Content>
    
    <NewWaterPoint ref="newWaterPoint" v-on:submit="submitNewModal" :key="modalKey"></NewWaterPoint>
    
</template>

<script>

import axios from 'axios';
import Content from '@/components/Content.vue';
import WaterPointItem from '@/components/waterpoint/WaterPointItem.vue';
import NewWaterPoint from '@/components/waterpoint/NewWaterPoint.vue';
import Alert from '@/components/Alert.vue';

export
default {
    name: 'About',
    components: {
		Content,
        WaterPointItem,
        NewWaterPoint,
        Alert
    },
    inject: [
        'state',
        'config'
    ],
    data: function () {
        return {
            year: 0,
            loading: false,
            alertEmpty: false,
            alertNew: false,
            modalKey: 0
        }
    },
    computed: {
        waterPointList: function() {
            let waterPointList = [].concat(this.state.waterPoint.list);
        
            return waterPointList.sort(function(p1, p2) {
               return (p2.id - p1.id);
            });
           
        },
        routeTo: function() {
            let path = '/';
            let query = {}; 
            let referrer = this.$route.query.referrer;
            
            if (referrer) {
                path = decodeURIComponent(referrer);
                return path;
            }
            
            return Object.assign({path: path}, {query: query});
        },
        isReferrer: function() {
            if (this.$route.query.referrer) {
                return true;
            }
            return false;
        }
    },
    methods: {
        openNewModal: function () {
            this.modalKey = this.modalKey + 1;
            this.$nextTick(function() { 
                this.$refs.newWaterPoint.openModal();
            });
        },
        submitNewModal: function (label, waterPointType, position, maxWithdrawal, gaugeMark, gaugeMarkPosition) {
            let self = this;
            
            self.alertNew = false;
            self.addData(label, waterPointType, position, maxWithdrawal, gaugeMark, gaugeMarkPosition, function () {
                self.alertNew = true;
            });

        },
        setSelectedWaterPoint: function (waterPoint) {
            this.state.actions.waterPoint.setId(waterPoint.id);
        },
        fetchData: function (callback) {
            let self = this;
                       
            let query = {
                query: `
                    query {
                        waterPoints {
                            id
                            label
                            typ
                            latitude
                            longitude
                            maxWithdrawal
                            gaugeMark
                            gaugeMarkPosition
                            totalWithdrawal
                            lastStillWaterLevel
                        }
                        loggedIn
                    }
                `,      
                variables: {
                }           
            }
            
            let request = Object.assign({}, self.config.request);
            request["data"] = query;
            
            self.loading = true;
            
            axios(request).then( function (response) {
                let data = response.data.data;
            
                if ( data !== null ) {
                    self.state.actions.waterPoint.setList(data.waterPoints);
                } else {
                    console.log(data);    
                }
            
            }).catch(function (error) {
                console.log(error);
            }).then(function () {
                self.loading = false;
                
                 if (callback) {
                    callback(self);
                }
                
            });
        },
        addData: function (label, waterPointType, position, maxWithdrawal,gaugeMark, gaugeMarkPosition, callback) {
            let self = this;
                       
            let query = {
                query: `
                    mutation (
                        $label: String!,
                        $typ: String!,
                        $latitude: Float!,        
                        $longitude: Float!,
                        $maxWithdrawal: Float,
                        $gaugeMark: Float, 
                        $gaugeMarkPosition: String
                    ) {
                       newWaterpoint (
                        label: $label,
                        typ: $typ, 
                        latitude: $latitude,
                        longitude: $longitude,
                        maxWithdrawal: $maxWithdrawal,
                        gaugeMark: $gaugeMark,
                        gaugeMarkPosition: $gaugeMarkPosition
                             ) {
                            success
                            waterPointId
                            waterPoints {
                              id
                              label
                              typ
                              latitude
                              longitude
                              maxWithdrawal
                              totalWithdrawal
                            }
                          }
                        }
                `,      
                variables: {
                    label: label,
                    typ: waterPointType,
                    latitude: position.latitude,
                    longitude: position.longitude,
                    maxWithdrawal: maxWithdrawal,
                    gaugeMark: gaugeMark,
                    gaugeMarkPosition: gaugeMarkPosition
                }           
            }
            
            let request = Object.assign({}, self.config.request);
            request["data"] = query;
            
            self.loading = true;
            
            axios(request).then( function (response) {
                let data = response.data.data;
                
                if ( data !== null ) {
                    self.state.actions.waterPoint.setList(data.newWaterpoint.waterPoints);
                } else {
                    console.log(data);    
                }
            
            }).catch(function (error) {
                console.log(error);
            }).then(function () {
                self.loading = false;
                
                if (callback) {
                    callback(self);
                }
            });
        }
    },
    watch: {
        loading: function (new_value, old_value) {
            // LOADING STARTING
            if ( new_value === true && old_value === false ) {
                this.alertEmpty = false; 
            }
            // LOADING FINISHED
            if ( new_value === false && old_value === true ) {
                if (this.waterPointList.length == 0) {
                    this.alertEmpty = true;
                } else {
                    this.alertEmpty = false;
                }      
            }
        }    
    },
    created: function ()  {
        this.fetchData();
    }
}

</script>
